/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Credentials_ReadyInputs */

const cs_sreality_credentials_ready = /** @type {(inputs: Sreality_Credentials_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíče RK uloženy`)
};

const en_sreality_credentials_ready = /** @type {(inputs: Sreality_Credentials_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK keys saved`)
};

/**
* | output |
* | --- |
* | "RK keys saved" |
*
* @param {Sreality_Credentials_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_credentials_ready = /** @type {((inputs?: Sreality_Credentials_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Credentials_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_credentials_ready(inputs)
	return cs_sreality_credentials_ready(inputs)
});